<template>
  <div class="fullpage-container" ref="fullContainer" v-on:scroll="onScroll">
    <transition name="showBanner">
    <div id="df-banner" v-if="showBanner" v-bind:class="{ inActive: isCloseBanner }">
        <span class="banner-text-box" @click="goDeepLinkUrl">
          <a class="banner-text">
            지금 다운로드하세요!
          </a>
        </span>
      <span class="banner-btn-box">
          <a class="banner-btn" @click="isCloseBanner = true;"><font-awesome-icon :icon="['fas', 'times']"></font-awesome-icon></a>
        </span>
    </div>
    </transition>
    <div class="df-loader" v-if="!isLoadedDone">
      <span class="loader-box">
        <img src="../assets/loader.gif" alt="loader"/>
      </span>
    </div>
    <div class="fullpage-vertical" v-fullpage="opts">
      <div class="page container" id="home" v-bind:class="{ 'small-desktop': smallDeskTop, 'mini-desktop': miniDeskTop }">
        <DfNavbar/>
        <v-row class="home-row" v-bind:class="{ 'show-mobile' : $vuetify.breakpoint.smAndDown }">
        <transition name="moveLookup">
        <v-col cols="12" xs="12" sm="6" class="lookup-box">
          <transition name="jjazan">
            <div class="mockup-box" v-if="showMockup" v-bind:class="{ 'small-mobile': smallMobile }">
              <img class="mockup" @load="readyToShowMockup" src="../assets/w_mockup_400_box.png" alt="mouckup" />
            </div>
          </transition>
          <div class="lookup-inner" v-bind:class="{ 'small-mobile': smallMobile }">
            <transition name="ramhee">
            <img v-if="showRamhee" @load="readyToShowRamhee" class="ramhee" src="../assets/ramhee.png" alt="ramhee" />
            </transition>
            <ul class="msg-items">
              <transition name="msg1"><li class="msg-item" v-if="showMsg1" v-html="msgList[0]"></li></transition>
              <transition name="msg2"><li class="msg-item" v-if="showMsg2" v-html="msgList[1]"></li></transition>
              <transition name="msg3"><li class="msg-item" v-if="showMsg3" v-html="msgList[2]"></li></transition>
            </ul>
          </div>
        </v-col>
        </transition>
        <transition name="startDescBox">
        <v-col cols="12" xs="12" sm="6" class="desc-box animate__animated animate__fadeIn" v-if="endMsgMove && !$vuetify.breakpoint.smAndDown">
          <div class="desc-upper-box">
            <p class="main-title">당신을 위한 <strong>다이어트 코칭</strong> 챗봇</p>
            <img class="desc-logo" src="../assets/2951@3x.png" alt="logo" />
          </div>
          <div class="sub-title">
          </div>
          <div class="down-box">
            <ul class="down-btns">
              <li class="down-btn appstore"><a href="https://apps.apple.com/kr/app/%EB%8B%A4%EC%9D%B4%EC%96%B4%ED%8A%B8-%ED%94%84%EB%A0%8C%EC%A6%88/id1466899980" target="_blank"><img src="../assets/appstore.png" alt="appstore" /></a></li>
              <li class="down-btn google"><a href="https://play.google.com/store/apps/details?id=kr.dietfriends.android" target="_blank"><img src="../assets/google.png" alt="google" /></a></li>
            </ul>
          </div>
          <div class="blank"></div>
          <div class="blank"></div>
        </v-col>
        </transition>
        </v-row>
      </div>
      <Feature :isFeaturePageScrolled="showSlide[1]"/>
      <FeatureDetail :isFeatureDetailPageScrolled="showSlide[2]"/>
      <FeatureDetailSecond :isFeatureDetailPageScrolled="showSlide[3]"/>
      <Review :isReviewPageScrolled="showSlide[4]"/>
      <Last :isLastPageScrolled="showSlide[5]"/>
    </div>
    <div class="df-pagination" v-if="!$vuetify.breakpoint.smAndDown">
      <div class="df-pagination-bullet" v-for="(i,index) in [0,1,2,3,4,5]" v-bind:key="i" v-bind:class="{ active : slideIndex===index}"></div>
    </div>
  </div>
</template>

<script>
  import DfNavbar from "./DfNavbar";
  import Last from "./Last";
  import Review from "./Review";
  import FeatureDetail from "./FeatureDetail";
  import Feature from "./Feature";
  import FeatureDetailSecond from "./FeatureDetailSecond";

  export default {
    name: 'Home',
    data: function () {
        let that = this;
        return {
          deepLinkUrl: 'https://dietfriends.link/C35rDyW397',
          isMobile: false,
          deviceHeight: 0,
          smallDeskTop: false,
          miniDeskTop: false,
          smallMobile: false,
          showSlide: [false, false, false, false, false, false],
          slideIndex: 0,
          showMockup: false,
          showRamhee: false,
          showMsg1: false,
          showMsg2: false,
          showMsg3: false,
          endMsgMove: false,
          isLoadedDone: false,
          isScrolled: false,
          showBanner: false,
          isCloseBanner: false,
          msgList: [
              '어엇 혹시 람희를 찾아오신 건가요?',
              '혼자 외로웠는데 <br/> 너무 기뻐요! ( ´▽`)',
              '다이어트를 도와줄 테니 <br/>람희의 친구가 되어주실래요?'
          ],
          opts: {
            start: 0,
            dir: 'v',
            duration: 0,
            movingFlag: 'test',
            disabled: false,
            beforeChange: function(ele, next, current) {
              let isSlides = that.showSlide;
              setTimeout(()=> {
                isSlides.forEach((el, index)=>{
                    that.showSlide[index] = ( index === current );
                })
                that.slideIndex = current;
              }, 300);
            },
          }
    }},
    created: function () {
        this.deviceHeight = document.documentElement.clientHeight;
        if (this.$vuetify.breakpoint.mobile) {
            window.addEventListener('scroll', this.onScroll);
            this.isMobile = true;
            this.opts.disabled = true;
            if (this.deviceHeight < 600) {
                this.smallMobile = true;
            }
            if (typeof this.$refs.fullContainer !== 'undefined') {
                console.log('undefined fullContainer')
            } else {
                setTimeout(()=> {
                    let target = this.$refs.fullContainer;
                    target.style.overflowY = 'scroll';
                    for(let idx in this.showSlide) {
                        this.showSlide[idx] = true;
                    }
                }, 250);
            }
        } else {
            setTimeout(()=> {
                this.$zendesk.show();
            }, 3000);
            this.isMobile = false;
            if (this.deviceHeight < 800 && this.deviceHeight > 700) {
                this.smallDeskTop = true;
            } else if (this.deviceHeight <= 700) {
                this.miniDeskTop = true;
            }
        }
    },
    mounted() {
        setTimeout(() => {
            setTimeout(() => { this.showMockup = true; }, 500);
        }, 1000);
    },
    destroyed() {
        window.removeEventListener('scroll', this.onScroll);
    },
    methods: {
      readyToShowMockup: function () {
          this.isLoadedDone = true;
        this.showRamhee = true;
      },
      readyToShowRamhee: async function () {
          let showMsg = await (this.showRamhee === true);
          if (showMsg) {
            setTimeout(() => { this.showMsg1 = true; }, 500);
            setTimeout(() => { this.showMsg2 = true; }, 800);
            setTimeout(() => { this.showMsg3 = true; }, 1100);
            setTimeout(() => { this.endMsgMove = true; }, 1500);
          }
      },
      onScroll: function () {
          let windowTop = this.$refs.fullContainer.scrollTop;
          (windowTop -50) > this.deviceHeight ? this.showBanner = true : this.showBanner = false;
      },
      goDeepLinkUrl: function () {
          this.$mixpanel.track('Clicked Deep Link', { 'position': 'Mobile Banner' });
          return window.open(this.deepLinkUrl, '_blank');
      }
    },
    components: {
        FeatureDetailSecond,
        DfNavbar,
        Feature,
        FeatureDetail,
        Review,
        Last
    }
  }
</script>
<style lang="scss" scoped>
  @import '../variables.scss';
  #df-banner.inActive {
    display: none !important;
    transition: ease-in-out 0.2s;
  }
  #df-banner {
    position: fixed;
    top: 0;
    width: 100%;
    height: 50px;
    padding: 0 1rem;
    background:#dcfffd;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    z-index: 99999;
    .banner-text-box {
      width: 100%;
      z-index: 99;
    }
    .banner-text {
      width: 100%;
      margin: 0;
      font-size: 1.2em;
      line-height: 50px;
      font-family: $brandFont;
      color: $basicFontColor;
      text-decoration: none;
    }
    .banner-btn-box {
      position: absolute;
      right: 0;
      bottom: 0;
      top: 0;
      margin: auto;
      z-index: 999;
    }
    .banner-btn {
      font-size: 1em;
      line-height: 50px;
      padding: 0 1rem;
      color: $basicFontColor;
    }
  }
  /*animate object*/
  .jjazan-enter-active {
    animation: fade-in-bottom .5s;
  }
  .jjazan-leave-active {
    animation: fade-in-bottom .5s reverse;
  }

  /*animate object*/
  .showBanner-enter-active {
    animation: fade-in-top .5s;
  }
  .showBanner-leave-active {
    animation: fade-in-top .5s reverse;
  }

  .ramhee-enter-active {
    animation: bounce-in-top 1s;
  }
  .ramhee-leave-active {
    animation: bounce-in-top 1s reverse;
  }

  .msg1-enter-active, .msg2-enter-active, .msg3-enter-active {
    animation: slide-in-left .2s;
  }
  .msg1-leave-active, .msg2-leave-active, .msg3-leave-active {
    animation: slide-in-left .2s reverse;
  }
  /***************/

  .fullpage-container {
    width: 100%;
    height: 100%;
  }

  .df-pagination {
    position: absolute;
    bottom: 50%;
    right: 20px;
    transform: translate(-50%,0);

    .df-pagination-bullet{
      margin:6px;
      display: block;
      cursor: pointer;
      width: 12px;
      height: 12px;
      border-radius: 100%;
      background: #cecece;
      opacity: .3;
    }
    .df-pagination-bullet.active{
      background: $primaryPinkColor;
      opacity: 1;
    }
  }

  .df-loader {
    position: fixed;
    background: $defaultBackgroundColor;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    .loader-box {
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
  }

  #home.mini-desktop {
    .lookup-inner {
      margin-top: 2rem !important;
      justify-content: flex-start !important;
      .ramhee {
        width: auto !important;
        height: 160px !important;
        margin-bottom: 2rem !important;
      }
      .msg-items {
        .msg-item {
          margin-bottom: 0.5rem !important;
          font-size: 0.8em !important;
        }
      }
    }
    .desc-box {
      justify-content: flex-start !important;
      .desc-upper-box {
        margin-top: 0 !important;
      }
      .down-box {
        margin-top: 8rem;
      }
      .main-title {
        margin-top: 2rem !important;
      }
    }
  }
  #home.small-desktop {
    .lookup-inner {
      margin-top: 0rem !important;
      justify-content: center !important;
      .ramhee {
        width: auto !important;
        height: 160px !important;
        margin-bottom: 2rem !important;
      }
      .msg-items {
        .msg-item {
          font-size: 0.9em !important;
        }
      }
    }
    .desc-box {
      justify-content: flex-start !important;
      .desc-upper-box {
        margin-top: 0 !important;
      }
      .down-box {
        margin-top: 8rem;
      }
    }
  }
  #home {
    position: relative;
    max-height: 100%;
    .home-row.show-mobile {
      padding: 0;
      .mockup-box.small-mobile {
        margin-top: 0 !important;
      }
      .mockup-box {
        margin-top: 50px;
        width: 100% !important;
        .mockup {
          width: 92% !important;
        }
      }
      .lookup-inner.small-mobile {
        justify-content: flex-start !important;
        margin-top: 0 !important;
        .ramhee {
          margin-top: 0.5rem !important;
          margin-bottom: 1rem !important;
        }
      }
      .lookup-inner {
        justify-content: center !important;
        max-width: 320px;
        margin-top: -30px;
        .ramhee {
          width: auto !important;
          height: 120px !important;
          max-height: 120px !important;
          margin-top: 0 !important;
          margin-bottom: 2rem;
        }
        .msg-items {
          .msg-item {
            padding: 1rem;
            margin-bottom: 0.5rem;
            display: block;
            width: 240px;
            border-radius: 0 10px 10px 10px;
            box-shadow: $basicBoxShadow;
            background: $lookUpChatBoxColor;
            font-family: $basicFont;
            text-align: left;
            font-size: 1em;
            font-weight: bold;
          }
        }
      }
    }
    .home-row {
      height: 100%;
      display: flex;
      text-align: center;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      padding-left: 2rem;
    }
    .lookup-box {
      position: relative;
      width: 429px;
      height: 100%;
      max-height: 800px;
      z-index: 10;
      display: flex;
      justify-content: space-evenly;
      align-items: flex-start;
      .mockup-box {
        position: absolute;
        width: 470px;
        height: auto;
        margin: auto;
        .mockup {
          margin-top: -50px;
          width: 470px;
          height: auto;
          min-height: 434px;
          min-width: 200px;
          max-width: 470px;
          max-height: 938px;
          z-index: 99;
        }
      }
      .lookup-inner {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-evenly;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        z-index: 200;
        height: auto;
        max-height: 700px;
        width: 470px;
        padding: 0 0 1.6rem 0;

        .ramhee {
          max-width: 270px;
          width: auto;
          height: 240px;
          margin-bottom: 2rem;
        }

        .msg-items {
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 0;
          .msg-item {
            padding: 1rem;
            margin-bottom: 1rem;
            display: block;
            width: 300px;
            border-radius: 0 10px 10px 10px;
            box-shadow: $basicBoxShadow;
            background: $lookUpChatBoxColor;
            font-family: $basicFont;
            text-align: left;
            font-size: 1.1em;
            font-weight: bold;
          }
        }
      }
    }
    .desc-box {
      display: flex;
      flex: 1.1;
      flex-direction: column;
      height: 100%;
      justify-content: space-evenly;
      align-items: flex-start;

      .desc-upper-box {
        display: flex;
        justify-content: center;
        align-items: flex-start;
        flex-direction: column;
      }
      .main-title {
        font-family: $basicFont;
        color: $basicFontColor;
        font-size: 2em;
        font-weight: bold;
        margin: 6rem 0 2rem 0;
        strong {
          background-color: $primaryBlueColor;
          padding: 0.5rem;
          color: white;
        }
      }
      .desc-logo {
        width: 100%;
      }
      .down-box {
        margin-top: 5rem;
        text-align: left;
        .down-btns {
          display: flex;
          flex-direction: row;
          align-items: center;
          padding: 0;

          .down-btn {
            width: 100%;
            text-align: left;
            margin-right: 0.6rem;

            img {
              height: 60px;
              width: auto;
            }
          }
        }
      }

    }

  }
</style>
